/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  AutoAcceptPaymentsUpdateRequest,
  ChangePinRequest,
  DataResponseListCardSummary,
  ErrorResponse,
  GetParticipantsParticipantsGetParams,
  HTTPValidationError,
  LanguageUpdateRequest,
  ParticipantCreate,
  ParticipantListResponse,
  ParticipantLoginRequest,
  ParticipantLoginResponse,
  ParticipantOnboardingRequest,
  ParticipantRead,
  ParticipantStudy,
  ParticipantUpdate,
  ResetPinRequest,
  ResetPinResponse,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Create Participant
 */
export const createParticipantParticipantsPost = (
  participantCreate: BodyType<ParticipantCreate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    {
      url: `/participants`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: participantCreate,
      signal,
    },
    options
  );
};

export const getCreateParticipantParticipantsPostMutationKey = () =>
  ["createParticipantParticipantsPost"] as const;

export const getCreateParticipantParticipantsPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createParticipantParticipantsPost>>,
    TError,
    CreateParticipantParticipantsPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createParticipantParticipantsPost>>,
  TError,
  CreateParticipantParticipantsPostMutationVariables,
  TContext
> => {
  const mutationKey = getCreateParticipantParticipantsPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createParticipantParticipantsPost>>,
    CreateParticipantParticipantsPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return createParticipantParticipantsPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateParticipantParticipantsPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createParticipantParticipantsPost>>
>;
export type CreateParticipantParticipantsPostMutationBody =
  BodyType<ParticipantCreate>;
export type CreateParticipantParticipantsPostMutationError =
  ErrorType<ErrorResponse>;
export interface CreateParticipantParticipantsPostMutationVariables {
  data: BodyType<ParticipantCreate>;
}

/**
 * @summary Create Participant
 */
export const useCreateParticipantParticipantsPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createParticipantParticipantsPost>>,
      TError,
      CreateParticipantParticipantsPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createParticipantParticipantsPost>>,
  TError,
  CreateParticipantParticipantsPostMutationVariables,
  TContext
> => {
  return useMutation(
    getCreateParticipantParticipantsPostMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Get Participants
 */
export const getParticipantsParticipantsGet = (
  params?: GetParticipantsParticipantsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantListResponse>(
    { url: `/participants`, method: "GET", params, signal },
    options
  );
};

export const getGetParticipantsParticipantsGetQueryKey = (
  params?: GetParticipantsParticipantsGetParams
) => {
  return [`/participants`, ...(params ? [params] : [])] as const;
};

export const getGetParticipantsParticipantsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetParticipantsParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetParticipantsParticipantsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getParticipantsParticipantsGet>>
  > = ({ signal }) =>
    getParticipantsParticipantsGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetParticipantsParticipantsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantsParticipantsGet>>
>;
export type GetParticipantsParticipantsGetQueryError =
  ErrorType<HTTPValidationError>;

export function useGetParticipantsParticipantsGet<
  TData = Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetParticipantsParticipantsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantsParticipantsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantsParticipantsGet<
  TData = Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetParticipantsParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantsParticipantsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantsParticipantsGet<
  TData = Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetParticipantsParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Participants
 */

export function useGetParticipantsParticipantsGet<
  TData = Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetParticipantsParticipantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantsParticipantsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetParticipantsParticipantsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Returns the authenticated participant's own profile.
 * @summary Get my participant info
 */
export const getParticipantMeParticipantsMeGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    { url: `/participants/me`, method: "GET", signal },
    options
  );
};

export const getGetParticipantMeParticipantsMeGetQueryKey = () => {
  return [`/participants/me`] as const;
};

export const getGetParticipantMeParticipantsMeGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetParticipantMeParticipantsMeGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>
  > = ({ signal }) => getParticipantMeParticipantsMeGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetParticipantMeParticipantsMeGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>
>;
export type GetParticipantMeParticipantsMeGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetParticipantMeParticipantsMeGet<
  TData = Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantMeParticipantsMeGet<
  TData = Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
          TError,
          Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantMeParticipantsMeGet<
  TData = Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get my participant info
 */

export function useGetParticipantMeParticipantsMeGet<
  TData = Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantMeParticipantsMeGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetParticipantMeParticipantsMeGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Participant
 */
export const getParticipantParticipantsParticipantIdGet = (
  participantId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    { url: `/participants/${participantId}`, method: "GET", signal },
    options
  );
};

export const getGetParticipantParticipantsParticipantIdGetQueryKey = (
  participantId: string
) => {
  return [`/participants/${participantId}`] as const;
};

export const getGetParticipantParticipantsParticipantIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getParticipantParticipantsParticipantIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetParticipantParticipantsParticipantIdGetQueryKey(participantId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>
  > = ({ signal }) =>
    getParticipantParticipantsParticipantIdGet(
      participantId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: participantId !== null && participantId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetParticipantParticipantsParticipantIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>
>;
export type GetParticipantParticipantsParticipantIdGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetParticipantParticipantsParticipantIdGet<
  TData = Awaited<
    ReturnType<typeof getParticipantParticipantsParticipantIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getParticipantParticipantsParticipantIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantParticipantsParticipantIdGet<
  TData = Awaited<
    ReturnType<typeof getParticipantParticipantsParticipantIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getParticipantParticipantsParticipantIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantParticipantsParticipantIdGet<
  TData = Awaited<
    ReturnType<typeof getParticipantParticipantsParticipantIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Participant
 */

export function useGetParticipantParticipantsParticipantIdGet<
  TData = Awaited<
    ReturnType<typeof getParticipantParticipantsParticipantIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getParticipantParticipantsParticipantIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetParticipantParticipantsParticipantIdGetQueryOptions(
      participantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Participant
 */
export const updateParticipantParticipantsParticipantIdPatch = (
  participantId: string,
  participantUpdate: BodyType<ParticipantUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    {
      url: `/participants/${participantId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: participantUpdate,
      signal,
    },
    options
  );
};

export const getUpdateParticipantParticipantsParticipantIdPatchMutationKey =
  () => ["updateParticipantParticipantsParticipantIdPatch"] as const;

export const getUpdateParticipantParticipantsParticipantIdPatchMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>
      >,
      TError,
      UpdateParticipantParticipantsParticipantIdPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>>,
    TError,
    UpdateParticipantParticipantsParticipantIdPatchMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateParticipantParticipantsParticipantIdPatchMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>
      >,
      UpdateParticipantParticipantsParticipantIdPatchMutationVariables
    > = (props) => {
      const { participantId, data } = props ?? {};

      return updateParticipantParticipantsParticipantIdPatch(
        participantId,
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateParticipantParticipantsParticipantIdPatchMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>>
  >;
export type UpdateParticipantParticipantsParticipantIdPatchMutationBody =
  BodyType<ParticipantUpdate>;
export type UpdateParticipantParticipantsParticipantIdPatchMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UpdateParticipantParticipantsParticipantIdPatchMutationVariables {
  participantId: string;
  data: BodyType<ParticipantUpdate>;
}

/**
 * @summary Update Participant
 */
export const useUpdateParticipantParticipantsParticipantIdPatch = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>
      >,
      TError,
      UpdateParticipantParticipantsParticipantIdPatchMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPatch>>,
  TError,
  UpdateParticipantParticipantsParticipantIdPatchMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateParticipantParticipantsParticipantIdPatchMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Update Participant
 */
export const updateParticipantParticipantsParticipantIdPut = (
  participantId: string,
  participantUpdate: BodyType<ParticipantUpdate>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    {
      url: `/participants/${participantId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: participantUpdate,
      signal,
    },
    options
  );
};

export const getUpdateParticipantParticipantsParticipantIdPutMutationKey = () =>
  ["updateParticipantParticipantsParticipantIdPut"] as const;

export const getUpdateParticipantParticipantsParticipantIdPutMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>,
    TError,
    UpdateParticipantParticipantsParticipantIdPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>,
  TError,
  UpdateParticipantParticipantsParticipantIdPutMutationVariables,
  TContext
> => {
  const mutationKey =
    getUpdateParticipantParticipantsParticipantIdPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>,
    UpdateParticipantParticipantsParticipantIdPutMutationVariables
  > = (props) => {
    const { participantId, data } = props ?? {};

    return updateParticipantParticipantsParticipantIdPut(
      participantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateParticipantParticipantsParticipantIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>
  >;
export type UpdateParticipantParticipantsParticipantIdPutMutationBody =
  BodyType<ParticipantUpdate>;
export type UpdateParticipantParticipantsParticipantIdPutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UpdateParticipantParticipantsParticipantIdPutMutationVariables {
  participantId: string;
  data: BodyType<ParticipantUpdate>;
}

/**
 * @summary Update Participant
 */
export const useUpdateParticipantParticipantsParticipantIdPut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>,
      TError,
      UpdateParticipantParticipantsParticipantIdPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateParticipantParticipantsParticipantIdPut>>,
  TError,
  UpdateParticipantParticipantsParticipantIdPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateParticipantParticipantsParticipantIdPutMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Delete Participant
 */
export const deleteParticipantParticipantsParticipantIdDelete = (
  participantId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/participants/${participantId}`, method: "DELETE", signal },
    options
  );
};

export const getDeleteParticipantParticipantsParticipantIdDeleteMutationKey =
  () => ["deleteParticipantParticipantsParticipantIdDelete"] as const;

export const getDeleteParticipantParticipantsParticipantIdDeleteMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>
      >,
      TError,
      DeleteParticipantParticipantsParticipantIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>
    >,
    TError,
    DeleteParticipantParticipantsParticipantIdDeleteMutationVariables,
    TContext
  > => {
    const mutationKey =
      getDeleteParticipantParticipantsParticipantIdDeleteMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>
      >,
      DeleteParticipantParticipantsParticipantIdDeleteMutationVariables
    > = (props) => {
      const { participantId } = props ?? {};

      return deleteParticipantParticipantsParticipantIdDelete(
        participantId,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteParticipantParticipantsParticipantIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>>
  >;

export type DeleteParticipantParticipantsParticipantIdDeleteMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface DeleteParticipantParticipantsParticipantIdDeleteMutationVariables {
  participantId: string;
}

/**
 * @summary Delete Participant
 */
export const useDeleteParticipantParticipantsParticipantIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>
      >,
      TError,
      DeleteParticipantParticipantsParticipantIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteParticipantParticipantsParticipantIdDelete>>,
  TError,
  DeleteParticipantParticipantsParticipantIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getDeleteParticipantParticipantsParticipantIdDeleteMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Get Participant Cards
 */
export const getParticipantCardsParticipantsParticipantIdCardsGet = (
  participantId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseListCardSummary>(
    { url: `/participants/${participantId}/cards`, method: "GET", signal },
    options
  );
};

export const getGetParticipantCardsParticipantsParticipantIdCardsGetQueryKey = (
  participantId: string
) => {
  return [`/participants/${participantId}/cards`] as const;
};

export const getGetParticipantCardsParticipantsParticipantIdCardsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
    >,
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
  >(
    participantId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getParticipantCardsParticipantsParticipantIdCardsGet
            >
          >,
          TError,
          TData
        >
      >;
      request?: SecondParameter<typeof nmibleInstanceV3>;
    }
  ) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetParticipantCardsParticipantsParticipantIdCardsGetQueryKey(
        participantId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
      >
    > = ({ signal }) =>
      getParticipantCardsParticipantsParticipantIdCardsGet(
        participantId,
        requestOptions,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: participantId !== null && participantId !== undefined,
      ...queryOptions,
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetParticipantCardsParticipantsParticipantIdCardsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
    >
  >;
export type GetParticipantCardsParticipantsParticipantIdCardsGetQueryError =
  ErrorType<ErrorResponse | HTTPValidationError>;

export function useGetParticipantCardsParticipantsParticipantIdCardsGet<
  TData = Awaited<
    ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantCardsParticipantsParticipantIdCardsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getParticipantCardsParticipantsParticipantIdCardsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getParticipantCardsParticipantsParticipantIdCardsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantCardsParticipantsParticipantIdCardsGet<
  TData = Awaited<
    ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantCardsParticipantsParticipantIdCardsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getParticipantCardsParticipantsParticipantIdCardsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getParticipantCardsParticipantsParticipantIdCardsGet
            >
          >
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetParticipantCardsParticipantsParticipantIdCardsGet<
  TData = Awaited<
    ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantCardsParticipantsParticipantIdCardsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Participant Cards
 */

export function useGetParticipantCardsParticipantsParticipantIdCardsGet<
  TData = Awaited<
    ReturnType<typeof getParticipantCardsParticipantsParticipantIdCardsGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  participantId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getParticipantCardsParticipantsParticipantIdCardsGet
          >
        >,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetParticipantCardsParticipantsParticipantIdCardsGetQueryOptions(
      participantId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Reset Pin
 */
export const resetPinParticipantsParticipantIdPinResetPost = (
  participantId: string,
  resetPinRequest: BodyType<ResetPinRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ResetPinResponse>(
    {
      url: `/participants/${participantId}/pin/reset`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: resetPinRequest,
      signal,
    },
    options
  );
};

export const getResetPinParticipantsParticipantIdPinResetPostMutationKey = () =>
  ["resetPinParticipantsParticipantIdPinResetPost"] as const;

export const getResetPinParticipantsParticipantIdPinResetPostMutationOptions = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>,
    TError,
    ResetPinParticipantsParticipantIdPinResetPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>,
  TError,
  ResetPinParticipantsParticipantIdPinResetPostMutationVariables,
  TContext
> => {
  const mutationKey =
    getResetPinParticipantsParticipantIdPinResetPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>,
    ResetPinParticipantsParticipantIdPinResetPostMutationVariables
  > = (props) => {
    const { participantId, data } = props ?? {};

    return resetPinParticipantsParticipantIdPinResetPost(
      participantId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPinParticipantsParticipantIdPinResetPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>
  >;
export type ResetPinParticipantsParticipantIdPinResetPostMutationBody =
  BodyType<ResetPinRequest>;
export type ResetPinParticipantsParticipantIdPinResetPostMutationError =
  ErrorType<HTTPValidationError>;
export interface ResetPinParticipantsParticipantIdPinResetPostMutationVariables {
  participantId: string;
  data: BodyType<ResetPinRequest>;
}

/**
 * @summary Reset Pin
 */
export const useResetPinParticipantsParticipantIdPinResetPost = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>,
      TError,
      ResetPinParticipantsParticipantIdPinResetPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof resetPinParticipantsParticipantIdPinResetPost>>,
  TError,
  ResetPinParticipantsParticipantIdPinResetPostMutationVariables,
  TContext
> => {
  return useMutation(
    getResetPinParticipantsParticipantIdPinResetPostMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Change Pin
 */
export const changePinParticipantsPinChangePost = (
  changePinRequest: BodyType<ChangePinRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/participants/pin/change`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: changePinRequest,
      signal,
    },
    options
  );
};

export const getChangePinParticipantsPinChangePostMutationKey = () =>
  ["changePinParticipantsPinChangePost"] as const;

export const getChangePinParticipantsPinChangePostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>,
    TError,
    ChangePinParticipantsPinChangePostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>,
  TError,
  ChangePinParticipantsPinChangePostMutationVariables,
  TContext
> => {
  const mutationKey = getChangePinParticipantsPinChangePostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>,
    ChangePinParticipantsPinChangePostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return changePinParticipantsPinChangePost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangePinParticipantsPinChangePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>
>;
export type ChangePinParticipantsPinChangePostMutationBody =
  BodyType<ChangePinRequest>;
export type ChangePinParticipantsPinChangePostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface ChangePinParticipantsPinChangePostMutationVariables {
  data: BodyType<ChangePinRequest>;
}

/**
 * @summary Change Pin
 */
export const useChangePinParticipantsPinChangePost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>,
      TError,
      ChangePinParticipantsPinChangePostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof changePinParticipantsPinChangePost>>,
  TError,
  ChangePinParticipantsPinChangePostMutationVariables,
  TContext
> => {
  return useMutation(
    getChangePinParticipantsPinChangePostMutationOptions(options),
    queryClient
  );
};
/**
 * Sets whether the authenticated participant's stipends and micropayments are accepted without them acting. Turning it on also accepts everything they already have pending. Turning it off, which is also how the Home banner is dismissed, leaves existing payments alone. Claims are unaffected either way.
 * @summary Turn auto-accept on or off for myself
 */
export const updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut = (
  autoAcceptPaymentsUpdateRequest: BodyType<AutoAcceptPaymentsUpdateRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantRead>(
    {
      url: `/participants/me/auto-accept-payments`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: autoAcceptPaymentsUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationKey =
  () => ["updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut"] as const;

export const getUpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationOptions =
  <
    TError = ErrorType<ErrorResponse | HTTPValidationError>,
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
      >,
      TError,
      UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
    >,
    TError,
    UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
      >,
      UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
    >
  >;
export type UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationBody =
  BodyType<AutoAcceptPaymentsUpdateRequest>;
export type UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationError =
  ErrorType<ErrorResponse | HTTPValidationError>;
export interface UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables {
  data: BodyType<AutoAcceptPaymentsUpdateRequest>;
}

/**
 * @summary Turn auto-accept on or off for myself
 */
export const useUpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
      >,
      TError,
      UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPut>
  >,
  TError,
  UpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateMyAutoAcceptParticipantsMeAutoAcceptPaymentsPutMutationOptions(
      options
    ),
    queryClient
  );
};
/**
 * @summary Update Participant Language
 */
export const updateParticipantLanguageParticipantsLanguageUpdatePut = (
  languageUpdateRequest: BodyType<LanguageUpdateRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<unknown>(
    {
      url: `/participants/language/update`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: languageUpdateRequest,
      signal,
    },
    options
  );
};

export const getUpdateParticipantLanguageParticipantsLanguageUpdatePutMutationKey =
  () => ["updateParticipantLanguageParticipantsLanguageUpdatePut"] as const;

export const getUpdateParticipantLanguageParticipantsLanguageUpdatePutMutationOptions =
  <TError = ErrorType<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateParticipantLanguageParticipantsLanguageUpdatePut
        >
      >,
      TError,
      UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateParticipantLanguageParticipantsLanguageUpdatePut>
    >,
    TError,
    UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables,
    TContext
  > => {
    const mutationKey =
      getUpdateParticipantLanguageParticipantsLanguageUpdatePutMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateParticipantLanguageParticipantsLanguageUpdatePut
        >
      >,
      UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables
    > = (props) => {
      const { data } = props ?? {};

      return updateParticipantLanguageParticipantsLanguageUpdatePut(
        data,
        requestOptions
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateParticipantLanguageParticipantsLanguageUpdatePut>
    >
  >;
export type UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationBody =
  BodyType<LanguageUpdateRequest>;
export type UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationError =
  ErrorType<HTTPValidationError>;
export interface UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables {
  data: BodyType<LanguageUpdateRequest>;
}

/**
 * @summary Update Participant Language
 */
export const useUpdateParticipantLanguageParticipantsLanguageUpdatePut = <
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateParticipantLanguageParticipantsLanguageUpdatePut
        >
      >,
      TError,
      UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateParticipantLanguageParticipantsLanguageUpdatePut>
  >,
  TError,
  UpdateParticipantLanguageParticipantsLanguageUpdatePutMutationVariables,
  TContext
> => {
  return useMutation(
    getUpdateParticipantLanguageParticipantsLanguageUpdatePutMutationOptions(
      options
    ),
    queryClient
  );
};
/**
 * @summary Onboard
 */
export const onboardParticipantsAuthOnboardPost = (
  participantOnboardingRequest: BodyType<ParticipantOnboardingRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantLoginResponse>(
    {
      url: `/participants/auth/onboard`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: participantOnboardingRequest,
      signal,
    },
    options
  );
};

export const getOnboardParticipantsAuthOnboardPostMutationKey = () =>
  ["onboardParticipantsAuthOnboardPost"] as const;

export const getOnboardParticipantsAuthOnboardPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>,
    TError,
    OnboardParticipantsAuthOnboardPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>,
  TError,
  OnboardParticipantsAuthOnboardPostMutationVariables,
  TContext
> => {
  const mutationKey = getOnboardParticipantsAuthOnboardPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>,
    OnboardParticipantsAuthOnboardPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return onboardParticipantsAuthOnboardPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type OnboardParticipantsAuthOnboardPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>
>;
export type OnboardParticipantsAuthOnboardPostMutationBody =
  BodyType<ParticipantOnboardingRequest>;
export type OnboardParticipantsAuthOnboardPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface OnboardParticipantsAuthOnboardPostMutationVariables {
  data: BodyType<ParticipantOnboardingRequest>;
}

/**
 * @summary Onboard
 */
export const useOnboardParticipantsAuthOnboardPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>,
      TError,
      OnboardParticipantsAuthOnboardPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof onboardParticipantsAuthOnboardPost>>,
  TError,
  OnboardParticipantsAuthOnboardPostMutationVariables,
  TContext
> => {
  return useMutation(
    getOnboardParticipantsAuthOnboardPostMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Login
 */
export const loginParticipantsAuthLoginPost = (
  participantLoginRequest: BodyType<ParticipantLoginRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantLoginResponse>(
    {
      url: `/participants/auth/login`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: participantLoginRequest,
      signal,
    },
    options
  );
};

export const getLoginParticipantsAuthLoginPostMutationKey = () =>
  ["loginParticipantsAuthLoginPost"] as const;

export const getLoginParticipantsAuthLoginPostMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>,
    TError,
    LoginParticipantsAuthLoginPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>,
  TError,
  LoginParticipantsAuthLoginPostMutationVariables,
  TContext
> => {
  const mutationKey = getLoginParticipantsAuthLoginPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>,
    LoginParticipantsAuthLoginPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return loginParticipantsAuthLoginPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginParticipantsAuthLoginPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>
>;
export type LoginParticipantsAuthLoginPostMutationBody =
  BodyType<ParticipantLoginRequest>;
export type LoginParticipantsAuthLoginPostMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface LoginParticipantsAuthLoginPostMutationVariables {
  data: BodyType<ParticipantLoginRequest>;
}

/**
 * @summary Login
 */
export const useLoginParticipantsAuthLoginPost = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>,
      TError,
      LoginParticipantsAuthLoginPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof loginParticipantsAuthLoginPost>>,
  TError,
  LoginParticipantsAuthLoginPostMutationVariables,
  TContext
> => {
  return useMutation(
    getLoginParticipantsAuthLoginPostMutationOptions(options),
    queryClient
  );
};
/**
 * Get study and site information for the authenticated participant
 *
 * `travel_rate_unit` is the site's Travel Rate Unit, `km` or `mi`. A mileage claim is converted to it, so a participant app can start the distance on that unit. It is null when the site has none set, and then `POST /mileage/calculate` and `POST /mileage` refuse with 409 `SIT-09`.
 * @summary Get My Study
 */
export const getMyStudyParticipantsMeStudyGet = (
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<ParticipantStudy>(
    { url: `/participants/me/study`, method: "GET", signal },
    options
  );
};

export const getGetMyStudyParticipantsMeStudyGetQueryKey = () => {
  return [`/participants/me/study`] as const;
};

export const getGetMyStudyParticipantsMeStudyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
  TError = ErrorType<ErrorResponse>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMyStudyParticipantsMeStudyGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>
  > = ({ signal }) => getMyStudyParticipantsMeStudyGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyStudyParticipantsMeStudyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>
>;
export type GetMyStudyParticipantsMeStudyGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetMyStudyParticipantsMeStudyGet<
  TData = Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
          TError,
          Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyStudyParticipantsMeStudyGet<
  TData = Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
          TError,
          Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyStudyParticipantsMeStudyGet<
  TData = Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Study
 */

export function useGetMyStudyParticipantsMeStudyGet<
  TData = Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMyStudyParticipantsMeStudyGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyStudyParticipantsMeStudyGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
